(function () {
  if (window.__mmaStorefrontMerchandisingTracking) return;
  window.__mmaStorefrontMerchandisingTracking = true;

  var trackingVersion = 'storefront_merchandising_20260819';

  function text(value) {
    return String(value == null ? '' : value);
  }

  function publish(eventName, details) {
    var payload = Object.assign({
      event: eventName,
      source: 'storefront_collection_filters',
      tracking_version: trackingVersion,
      page_path: window.location.pathname,
      page_query: window.location.search
    }, details || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
    document.dispatchEvent(new CustomEvent('mma:collection-filter', { detail: payload }));
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.filter-form input[type="checkbox"][data-mma-filter-label]');
    if (!input) return;
    publish(input.checked ? 'mma_collection_filter_applied' : 'mma_collection_filter_removed', {
      filter_label: text(input.getAttribute('data-mma-filter-label')),
      filter_value: text(input.getAttribute('data-mma-filter-value')),
      filter_parameter: text(input.name),
      filter_state: input.checked ? 'applied' : 'removed'
    });
  });

  document.addEventListener('click', function (event) {
    var clear = event.target.closest('#drawer-filter .drawer-footer .btn--secondary');
    if (!clear) return;
    publish('mma_collection_filters_cleared', {
      filter_state: 'cleared'
    });
  });
})();
